import { api } from '../api';

import type {
    CycleEvaluationGroupSendTestEmailRequest,
    CycleEvaluationSendTestEmailRequest,
    CycleInstanceSendTestEmailRequest,
} from './types';

export default {
    async sendCycleInstanceTestEmail({
        emailTitle,
        emailMessage,
        cycleInstanceId,
        emailAddress,
        selectedLang,
    }: CycleInstanceSendTestEmailRequest): Promise<void> {
        await api.post(`/sendtestemail/cycleinstance/${cycleInstanceId}`, {
            subject: emailTitle,
            htmlbody: emailMessage,
            emailAddress,
            selectedLang,
        });
    },

    async sendCycleEvaluationTestEmail({
        emailTitle,
        emailMessage,
        cycleEvaluationId,
        emailAddress,
        selectedLang,
        forEmployees,
    }: CycleEvaluationSendTestEmailRequest): Promise<void> {
        await api.post(`/sendtestemail/cycleevaluation/${cycleEvaluationId}`, {
            subject: emailTitle,
            htmlbody: emailMessage,
            emailAddress,
            selectedLang,
            forEmployees,
        });
    },

    async sendCycleEvaluationGroupTestEmail({
        emailTitle,
        emailMessage,
        cycleEvaluationGroupId,
        emailAddress,
        selectedLang,
    }: CycleEvaluationGroupSendTestEmailRequest): Promise<void> {
        await api.post(`/sendtestemail/cycleevaluationgroup/${cycleEvaluationGroupId}`, {
            subject: emailTitle,
            htmlbody: emailMessage,
            emailAddress,
            selectedLang,
        });
    },
};
